import { render } from "./MarkAllNotificationsAsReadIcon.vue?vue&type=template&id=7de64067"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/MarkAllNotificationsAsReadIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7de64067"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7de64067', __exports__)) {
    api.reload('7de64067', __exports__)
  }
  
  module.hot.accept("./MarkAllNotificationsAsReadIcon.vue?vue&type=template&id=7de64067", () => {
    api.rerender('7de64067', render)
  })

}


export default __exports__